import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import SuccessAlertModal from "../Modals/successAlertModal";
import { useNavigate } from "react-router-dom";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { Button, Row, Col, Container } from "react-bootstrap";
import Export from "../../icons/Export.svg";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";
import GridMaster from "../utility/grid/GridMaster";
import Toaster from "../utility/ui/notifications/Toaster";
import { getwpqlink } from "../../Services/WI-services";
import { RenderIf } from "../../functions/welding-functions";
import MultiValuePopUp from "../utility/ui/modals/MultiValuePopUp";
import { GridLoader } from "react-spinners";
import UnifiedActionRenderer from "../utility/grid/renderers/ActionRenderers/UnifiedActionRenderer";
import { handleExport1 } from "../utility/data/export/GlobalExport";
import { getLinkedWPQRecords, getWPQLinkingData } from "./WPQLinkingCommon";

const WPQ_Linking_Radio = {
  Linked: "Link WPQ with Project",
  UnLinked: "Linking WPQ with project not Required",
};

const JointHyperLink = ({ data, setJointType, setWIJointId, setWelData, showPopUp }) => {
  return (
    <Button
      variant="link"
      onClick={() => {
        setJointType(data.WI_Joint_Type);
        setWIJointId(data.WI_Joint_No);
        setWelData(data);
        if (data.WI_Wpq_Radio !== WPQ_Linking_Radio.UnLinked) {
          const welderIds = data.WI_Joint_No.split(",");
          let temp = [];
          for (let ele of welderIds) {
            temp.push({ "WCS_Joint_No": ele })
          }
          showPopUp("WPQJointNoGrid", "Multiple", "WI_Joint_No", temp);
        }
      }}
      size="sm"
    >
      {data.WI_Joint_No}
    </Button>
  );
};

const HyperLink = ({ data, setLoading, setJointType, setWelData, setWIWelderid, showPopUp }) => {
  return (
    <Button
      variant="link"
      onClick={async () => {
        setLoading(true);
        setJointType(data.WI_Joint_Type);
        setWelData(data);
        let linkedWpq = await getWPQLinkingData(data);
        let linkedData = await getLinkedWPQRecords(linkedWpq.join(","), data.WI_Joint_Type);
        setWIWelderid(linkedData);
        if (data.WI_Wpq_Radio !== WPQ_Linking_Radio.UnLinked) {
          showPopUp("WPQLinkGrid", "Multiple", "WI_Welder_Id", linkedData);
        }
        setLoading(false);
      }}
      size="sm"
    >
      {data.WI_Welder_Id}
    </Button>
  );
};

const WpqLinking = forwardRef((props, ref) => {
  const npcilflag = props.flag;
  const [welData, setWelData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [, setGroove] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [, setExcelData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [JointType, setJointType] = useState("");
  const [WIWelderid, setWIWelderid] = useState("");
  const [, setWIJointId] = useState("");
  const childRef = useRef();
  const year = new Date().getFullYear()

  const [showSuccess, setShowSuccess] = useState(false);

  const msg = "";
  const history = useNavigate();

  const [popUp, setPopUp] = useState({
    name: "",
    type: "",
    key: "",
    value: "",
  });

  const showPopUp = (name, type, key, value) => {
    setPopUp({ name, type, key, value });
    setShowForm(true);
  };



  const tmpcolumnDefs = [
    {
      headerName: "Project No.",
      field: "WI_Project_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Joint Type",
      field: "WI_Joint_Type",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Joint No.",
      field: "WI_Joint_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Linked WPQs",
      field: "WI_Welder_Id",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    }
  ];

  const excelColumnDefs = [
    {
      headerName: "Project No.",
      field: "WI_Project_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Joint Type",
      field: "WI_Joint_Type",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Joint No.",
      field: "WI_Joint_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Welder Id",
      field: "WPQ_WelderId",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Welder Name",
      field: "WPQ_WelderName",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "WPQ Record Number",
      field: "WPQ_RecordNo",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Inspection Agency",
      field: "WPQ_Inspection",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Qualification Code",
      field: "WPQ_Qualificationcode",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Plant Location",
      field: "WPQ_PlantLocation",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Special Notes",
      field: "WPQ_specialNote",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    }
  ];

  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  const fetchLinking = async () => {
    const startYear = parseInt(process.env.REACT_APP_START_YEAR) || 2023;
    const currentYear = new Date().getFullYear();
    
    setLoading(true);
    
    try {
      const result = await getwpqlink(npcilflag);
      if (result && result.length > 0) {
        // Filter for all years from startYear to currentYear
        const filter = result.filter(item => {
          if (item.WI_Createdon) {
            const yearPart = parseInt(item.WI_Createdon.split("-")[0]);
            return yearPart >= startYear && yearPart <= currentYear;
          }
          return false;
        });
        
        // Sort by year descending (most recent first)
        filter.sort((a, b) => {
          const yearA = parseInt(a.WI_Createdon?.split("-")[0] || 0);
          const yearB = parseInt(b.WI_Createdon?.split("-")[0] || 0);
          return yearB - yearA;
        });
        
        setGroove(filter);
        setFilteredResult(filter);
        fetchColumnDefns();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchColumnDefns = () => {
    const result = GlobalColumnDefinations(tmpcolumnDefs);
    result[2].cellRenderer = (params) => <JointHyperLink data={params.data} setJointType={setJointType} setWIJointId={setWIJointId} setWelData={setWelData} showPopUp={showPopUp} />;
    result[3].cellRenderer = (params) => <HyperLink data={params.data} setLoading={setLoading} setJointType={setJointType} setWelData={setWelData} setWIWelderid={setWIWelderid} showPopUp={showPopUp} />;
    result.push({
      headerName: "",
      cellRenderer: actionRenderer,
      minWidth: 250,
      suppressMenu: true,
      sortable: false,
    });
    setColumnDefs(result);
  };

  useEffect(() => {
    fetchLinking();
  }, [npcilflag]);

  function handleClick() {
    navigate("/Wpqlinking/AddEdit", {
      state: { data: "", action: "Add" },
    });
  }

  function handleClickedit(row) {
    navigate("/Wpqlinking/AddEdit", {
      state: {
        data: row,
        action: "Edit",
      }
    });
  }

  useImperativeHandle(ref, () => ({
    handleAdd: () => {
      handleClick();
    },
  }));

  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setGroove",
    });
  };

  const handleCloseSuccess = () => setShowSuccess(false);

  const handleGlobalSearch = (text) => {
    childRef.current.setSearch(text);
  };

  const handleGlobalExport = async () => {
    let filename = "WpqLinking";
    const allFields = [
      "WI_Project_No",
      "WI_Joint_Type",
      "WI_Joint_No",
      "WPQ_RecordNo",
      "WPQ_Inspection",
      "WPQ_PlantLocation",
      "WPQ_Qualificationcode",
      "WPQ_specialNote"
    ];

    // Create column definitions for all fields
    const allColumnDefs = allFields.map(field => ({
      headerName: field,
      field: field,
    }));

    // Add a column for WPQ_WelderName
    allColumnDefs.push({
      headerName: 'WPQ_WelderName',
      field: 'WPQ_WelderName',
    });

    allColumnDefs.push({
      headerName: 'WPQ_WelderId',
      field: 'WPQ_WelderId',
    });

    allColumnDefs.push({
      headerName: 'WPQ_RecordNo',
      field: 'WPQ_RecordNo',
    });

    allColumnDefs.push({
      headerName: 'WPQ_Inspection',
      field: 'WPQ_Inspection',
    });

    allColumnDefs.push({
      headerName: 'WPQ_PlantLocation',
      field: 'WPQ_PlantLocation',
    });

    allColumnDefs.push({
      headerName: 'WPQ_Qualificationcode',
      field: 'WPQ_Qualificationcode',
    });

    allColumnDefs.push({
      headerName: 'WPQ_specialNote',
      field: 'WPQ_specialNote',
    });

    // Process filteredResult to include WPQ_WelderName
    const processedResult = await Promise.all(filteredResult.map(async (item) => {

      let eachNpcilWPQSKs = await getWPQLinkingData(item);
      const linkedData = await getLinkedWPQRecords(eachNpcilWPQSKs.join(","), item.WI_Joint_Type);

      // Join all WPQ_WelderName values into a single string      
      const welderId = linkedData.map(wpq => wpq.WPQ_WelderId).join(', ');
      const welderNames = linkedData.map(wpq => wpq.WPQ_WelderName).join(', ');
      const welderRecordNo = linkedData.map(wpq => wpq.WPQ_RecordNo).join(', ');
      const WelderInspection = linkedData.map(wpq => wpq.WPQ_Inspection).join(', ');
      const welderPlantlocation = linkedData.map(wpq => wpq.WPQ_PlantLocation).join(', ');
      const welderQualificationcode = linkedData.map(wpq => wpq.WPQ_Qualificationcode).join(', ');
      const welderSpecialnote = linkedData.map(wpq => wpq.WPQ_specialNote).join(', ');
      // Return a new object with the original data and the new WPQ_WelderName field
      return {
        ...item,
        WPQ_WelderId: welderId,
        WPQ_WelderName: welderNames,
        WPQ_RecordNo: welderRecordNo,
        WPQ_Inspection: WelderInspection,
        WPQ_PlantLocation: welderPlantlocation,
        WPQ_Qualificationcode: welderQualificationcode,
        WPQ_specialNote: welderSpecialnote,
      };
    }));

    setExcelData(processedResult);
    handleExport1(processedResult, filename, excelColumnDefs);
  };

  const actionRenderer = (params) => {
    return (
      <UnifiedActionRenderer
        actions={['edit']}
        selectedData={params}
        handleEditEvent={(params) => handleClickedit(params.data)}
      />
    );
  };



  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <GridLoader size={10} className="pageloader" />
        </div>
      )}
      <Container fluid>
        <SuccessAlertModal
          clickFunction={modalOnClick}
          msg={msg}
          show={showSuccess}
          handleClose={handleCloseSuccess}
        />
        <Row className="RowHeight">
          <Col md={2} sm={12} xs={12} className="ListTitle">
            WPQ Transaction list
          </Col>
          <Col>
            <div className="global-search-container">
              <GolbalSearch
                searchplaceholdertext={
                  "Search for " +
                  " Project No, Joint Type, Joint No, Linked WPQ"
                }
                withYear={false}
                filterFunc={handleGlobalSearch}
              />
              <img
                className="allexport"
                src={Export}
                alt="Export"
                onClick={handleGlobalExport}
              />
            </div>
          </Col>
        </Row>
        <GridMaster
          rowDetails={filteredResult}
          colDetails={columnDefs}
          fieldNames={fieldName}
          headerNames={headerName}
          setExcelData={setExcelData}
          ref={childRef}
        />
        <RenderIf isTrue={popUp.type === "Multiple" && showForm}>
          <MultiValuePopUp
            show={showForm}
            onHide={() => setShowForm(false)}
            masterName={popUp.name}
            paramkey={popUp.key}
            paramvalue={popUp.value}
            backdrop="static"
            JointType={JointType}
            WIWelderid={WIWelderid}
            wiobj={welData}
          />
        </RenderIf>
        <Toaster />
      </Container>
    </>
  );
});

export default WpqLinking;